module.exports = __webpack_public_path__ + "static/6305-woodrose-32-9c20fa9f2feeeb56f12677e6d43e9129.jpg";